import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../hooks/use-auth'

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, isLoading, needsOnboarding } = useAuth()
  const location = useLocation()

  if (isLoading) {
    return <div data-testid="loading">Loading...</div>
  }

  if (!user) {
    return <Navigate to="/login" replace />
  }

  // Lock the rest of the app behind the onboarding wizard while a seeded
  // default admin is still present. Only /onboarding itself is reachable
  // until the wizard completes.
  if (needsOnboarding && location.pathname !== '/onboarding') {
    return <Navigate to="/onboarding" replace />
  }

  return <>{children}</>
}
